// useScriptFetcher.js
import { useState, useCallback } from "react";
import axios from "axios";

export function useScriptFetcher(navigate) {
  const [script, setScript] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Memoize fetchScript
  const fetchScript = useCallback(
    async (scriptId) => {
      console.log("Fetching script: ", scriptId);
      setIsLoading(true);
      setError(null);
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          navigate("/login", { replace: true });
          return;
        }

        const response = await axios.get(`/api/scripts/${scriptId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setScript(response.data);
      } catch (err) {
        if (axios.isCancel(err)) {
          console.log("Request was canceled");
          return;
        } else if (err.response && err.response.status === 401) {
          // Token might be invalid or expired
          localStorage.removeItem("token");
          navigate("/login", { replace: true });
        } else if (err.response && err.response.status === 403) {
          // Subscription required or access denied
          const errorMessage = err.response.data?.message || "Access denied. Subscription required.";
          setError(errorMessage);
          // Log the full error for debugging
          console.error("403 Forbidden - Script fetch failed:", {
            message: errorMessage,
            status: err.response.status,
            data: err.response.data
          });
        } else {
          const errorMessage = err.response?.data?.message || err.message || "An error occurred while fetching the script";
          setError(errorMessage);
          console.error("An error occurred while fetching the script:", err);
        }
      } finally {
        setIsLoading(false);
      }
    },
    [navigate], // Dependencies
  );

  return { script, isLoading, error, fetchScript };
}
